import App from './components/app';
import './assets/fonts/fonts.css';
import './assets/styles/config.scss';

export default App;



